export default "__VITE_ASSET__THsY4Hkj__"